import {NgModule} from '@angular/core';
import {Service} from './service.class';
import InjectedMembers = Service.InjectedMembers;

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [InjectedMembers]
})
export class CommonModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/common.module.ts